import {
  IntegrationInstanceSelector,
  JSONInput,
  JupiterTheme,
} from '@jupiterone/jupiter-web-toolkit';
import {
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import HelpIcon from 'react-feather/dist/icons/help-circle';
import useJiraRuleConfigLogic, {
  JiraRuleConfigProps,
} from './useJiraRuleConfigLogic';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    full: {
      display: 'block',
      marginBottom: theme.spacing(1),
    },
  })
);

const textFields = [
  {
    name: 'summary',
    label: 'Summary',
    helpText: 'Summary of the Jira ticket. Used as the ticket title.',
  },
  {
    name: 'description',
    label: 'Description',
    multiline: true,
  },
  {
    name: 'project',
    label: 'Project',
    helpText: 'The unique Jira project id that the ticket will be created in.',
  },
  {
    name: 'issueType',
    label: 'Issue Type',
    helpText: 'The Jira issue type (e.g. Task).',
  },
  {
    name: 'entityClass',
    label: 'Entity Class',
    helpText:
      'The class of the new ticket entity that should be created in JupiterOne. (e.g. Vulnerability)',
  },
];

const JiraRuleConfig = (props: JiraRuleConfigProps) => {
  const classes = useStyles();
  const {
    jsonValue,
    internalActionState,
    disabled,
    handleChangeValue,
  } = useJiraRuleConfigLogic(props);
  return (
    <div>
      {textFields.map(({ name, label, helpText, multiline }) => (
        <TextField
          key={name}
          className={classes.full}
          fullWidth={true}
          onChange={handleChangeValue}
          name={name}
          multiline={multiline}
          rowsMax={5}
          value={internalActionState[name]}
          label={label}
          disabled={disabled}
          inputProps={{
            'aria-label': label,
          }}
          InputProps={{
            endAdornment: helpText && (
              <InputAdornment position="end">
                <Tooltip title={helpText}>
                  <IconButton>
                    <HelpIcon size={20} />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      ))}
      <IntegrationInstanceSelector
        disabled={disabled}
        value={internalActionState.integrationInstanceId}
        integrationFilter="jira"
        onSelect={(id: string) =>
          handleChangeValue({
            target: { name: 'integrationInstanceId', value: id },
          } as any)
        }
      />
      <JSONInput
        value={jsonValue}
        onChange={handleChangeValue}
        label={'Additional Fields'}
        disabled={disabled}
        name={'additionalFields'}
      />
    </div>
  );
};

export default JiraRuleConfig;
